(function ($) {

    function categoriesSlider() {
        $(".products_archive__categories").each(function () {
            var $this = $(this);
            // var containerWidth = $('.products_archive__categories-wrapper').innerWidth();
            // var wrapperWidth = 0;
            // if ($this.find('.swiper-slide')) {
            //     $this.find('.swiper-slide').each(function () {
            //         wrapperWidth = wrapperWidth + $(this).outerWidth();
            //     });
            // }
            // console.log(containerWidth);
            // console.log(wrapperWidth);
            var Categories = new Swiper($this[0], {
                slidesPerView: 'auto',
                loop: false,
                spaceBetween: 10,
                observer: true,
                watchOverflow: true,
                freeMode: true,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: '.products_archive__categories-next',
                    prevEl: '.products_archive__categories-prev',
                },
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                    draggable: true,
                },
                breakpoints: {
                    768: {
                        freeMode: false,
                        spaceBetween: 15,
                    },
                    1600: {
                        // freeMode: false,
                        slidesPerView: 8,
                    },
                }
            });
            // if (wrapperWidth > containerWidth){
            //     Categories.swiper.disable();
            // }
        });
    }

    var w = $(window).width();
    $( window ).on('resize', function() {
        if ($(window).width()==w) return;
        w = $(window).width();
        categoriesSlider();
    });

    $(document).gp_ready(function(){
        categoriesSlider();
    })

})(jQuery);
